export default __webpack_public_path__ + "static/media/Corporate-hover.09412f24.svg";